import config from '@/config/constants.js';
import { firebase, firestore } from "@/config/firebase";

import axios from "axios";


export default {
  namespaced: true,
  state: {
    status: '',
    status_action: '',
    dataUsers: [],
    dataCompanies: [],
    dataOwners: [],
    dataVendors: [],
    totals: [],
    tenant_id: '',
    user: JSON.parse(localStorage.getItem(config.token_key)),
    userRole: '',
    services: [],
    uxDocs: [],
    uxTenantDocs: [],
    tenantUsersUnsubscribe: null,
    globalUsersUnsubscribes: [],
    _globalLiveResolve: null,
    userAgentReferrals: {},
    referralsCache: null,
    _loadedRole: '',
    _loadGeneration: 0,
    list_invoices: []
  },
  mutations: {
    setInvoices(state, docs) {
      state.list_invoices = docs;
    },
    setUxDocs(state, docs) {
      state.uxDocs = docs;
    },
    setUxTenantDocs(state, docs) {
      state.uxTenantDocs = docs;
    },
    set_role(state, role) {
      state.userRole = role;
    },
    set_tenant(state, tenant_id) {
      state.tenant_id = tenant_id;
    },
    status_action(state, status) {
      state.status_action = status;
    },
    loading(state) {
      state.status = 'loading';
    },
    status(state, status) {
      state.status = status;
    },
    success(state) {
      state.status = '';
    },
    removeUsers(state, refreshData) {

      if (refreshData) {
        state.uxDocs = [];
        state.uxTenantDocs = [];
        state.dataOwners = [];
      }
      state.dataUsers = [];
      state.dataCompanies = [];

      state.totals['users'] = 0;
      state.totals['clients'] = 0;
      state.totals['received'] = 0;
      state.totals['sent'] = 0;
      state.totals['clients_active'] = 0;
    },
    setDataUsers(state, { users, userRole }) {
      const companies = new Set(['All']);
      let totalClients = 0, totalReceived = 0, totalSent = 0;
      for (const u of users) {
        if (u.company_name) companies.add(u.company_name.toLowerCase());
        totalClients += (u.agent_users || 0);
        totalReceived += (u.messagesReceived || 0);
        totalSent += (u.messagesSent || 0);
      }
      state.dataUsers = users;
      state.dataCompanies = [...companies];
      state.totals['users'] = users.length;
      state.totals['clients'] = totalClients;
      state.totals['received'] = totalReceived;
      state.totals['sent'] = totalSent;
      state._loadedRole = userRole;
    },
    refreshDataUsers(state) {
      state.dataUsers = [...state.dataUsers];
    },
    removeInvoices(state) {
      state.list_invoices = [];
    },
    copyUrl(state, data) {
      const user = state.dataUsers.find(x => x.id === data.id);
      if (user) {
        user.copied = true;
      }
    },
    copiedUrl(state, data) {
      const user = state.dataUsers.find(x => x.id === data.id);
      if (user) {
        user.copied = false;
      }
    },
    addUsers(state, data) {
      const users = data.list;
      const agentData = data.agentData;

      let userRolesToSearch = [state.userRole];
      if (state.userRole === "vendor") {
        userRolesToSearch.push("employee");
      }
      if (state.userRole === "agent") {
        userRolesToSearch.push("owner");
      }

      if (!state.dataUsers.find(x => x.id === users.id) && userRolesToSearch.includes(users.user_role)) {
        let xcompany = users.company_name;
        state.dataCompanies.push('All');
        if (xcompany) {
          const index = state.dataCompanies.findIndex(company => company === xcompany.toLowerCase());
          if (index === -1) {
            state.dataCompanies.push(xcompany.toLowerCase());
          }
        }
        let service_exists = state.services.find(o => o.value === users.service);
        const globalUser = state.uxDocs.find(u => u.id === users.owner_id);
        state.dataUsers.push({
          copied: false,
          id: users.id,
          owner_id: users.owner_id,
          device_tokens: (globalUser && globalUser.device_tokens) ? globalUser.device_tokens : [],
          push_notifications_enabled: (globalUser && globalUser.push_notifications_enabled === true) ? true : false,
          push_permission_status: (globalUser && globalUser.push_permission_status) ? globalUser.push_permission_status : null,
          push_permission_synced_at: (globalUser && globalUser.push_permission_synced_at) ? globalUser.push_permission_synced_at : null,
          tenant_id: users.tenant_id,
          name: users.first_name + " " + users.last_name,
          email: users.email,
          phone: users.phone_number ? users.phone_number.substring(2) : '',
          phone_current: users.phone_number ? users.phone_number.substring(2) : '',
          status: users.status,
          is_admin: ["vendor"].includes(users.user_role) ? true : (users.is_admin ? users.is_admin : false),
          messagesReceived: (users.messages_received) ? users.messages_received : 0,
          messagesSent: (users.messages_sent) ? users.messages_sent : 0,
          activeClients: agentData.active_clients,
          active_clients: users.active_clients ? users.active_clients : 0,
          vendor_inquiries: users.vendor_inquiries ? users.vendor_inquiries : 0,
          //clients
          AssignedAgent: (users.agent_id) ? users.agent_name : "",
          vendorInquiries: 0,
          url: users.short_url || "",
          first_login: users.first_login,
          has_logged_into_app: users.has_logged_into_app,

          //vendor
          company_name: (users.company_name) ? users.company_name : "",
          // service: (users.service) ? (typeof users.service === 'string') ? users.service : users.service.text : null,
          service: (service_exists) ? users.service : "",
          service_other: (service_exists) ? "" : users.service,
          user_role: users.user_role,
          vendor_id: users.vendor_id || null,
          created_at: users.created_at || null,
          profile_picture: (globalUser && globalUser.profile_picture) ? globalUser.profile_picture : null,
          first_name: users.first_name || '',
          last_name: users.last_name || '',
          location: users.location || null,
          address: (users.location && users.location.address) || '',
        });

        state.totals['users'] = state.dataUsers.length;
        state.totals['clients'] = state.totals['clients'] + agentData.agent_users;
        state.totals['received'] = state.totals['received'] + ((users.messages_received) ? users.messages_received : 0);
        state.totals['sent'] = state.totals['sent'] + ((users.messages_sent) ? users.messages_sent : 0);
      }

    },

    addUsersBatch(state, items) {
      let userRolesToSearch = [state.userRole];
      if (state.userRole === "vendor") userRolesToSearch.push("employee");
      if (state.userRole === "agent") userRolesToSearch.push("owner");

      const existingIds = new Set(state.dataUsers.map(u => u.id));
      const uxDocsMap = {};
      for (const doc of state.uxDocs) {
        uxDocsMap[doc.id] = doc;
      }

      const newUsers = [];
      const companies = new Set(state.dataCompanies);
      companies.add('All');
      let totalClients = state.totals['clients'] || 0;
      let totalReceived = state.totals['received'] || 0;
      let totalSent = state.totals['sent'] || 0;

      for (const { list: users, agentData } of items) {
        if (existingIds.has(users.id) || !userRolesToSearch.includes(users.user_role)) continue;
        existingIds.add(users.id);

        const xcompany = users.company_name;
        if (xcompany) companies.add(xcompany.toLowerCase());

        const service_exists = state.services.find(o => o.value === users.service);
        const globalUser = uxDocsMap[users.owner_id];

        newUsers.push({
          copied: false,
          id: users.id,
          owner_id: users.owner_id,
          device_tokens: (globalUser && globalUser.device_tokens) ? globalUser.device_tokens : [],
          push_notifications_enabled: (globalUser && globalUser.push_notifications_enabled === true) ? true : false,
          push_permission_status: (globalUser && globalUser.push_permission_status) ? globalUser.push_permission_status : null,
          push_permission_synced_at: (globalUser && globalUser.push_permission_synced_at) ? globalUser.push_permission_synced_at : null,
          tenant_id: users.tenant_id,
          name: users.first_name + " " + users.last_name,
          email: users.email,
          phone: users.phone_number ? users.phone_number.substring(2) : '',
          phone_current: users.phone_number ? users.phone_number.substring(2) : '',
          status: users.status,
          is_admin: ["vendor"].includes(users.user_role) ? true : (users.is_admin ? users.is_admin : false),
          messagesReceived: (users.messages_received) ? users.messages_received : 0,
          messagesSent: (users.messages_sent) ? users.messages_sent : 0,
          activeClients: agentData.active_clients,
          active_clients: users.active_clients ? users.active_clients : 0,
          vendor_inquiries: users.vendor_inquiries ? users.vendor_inquiries : 0,
          AssignedAgent: (users.agent_id) ? users.agent_name : "",
          vendorInquiries: 0,
          url: users.short_url || "",
          first_login: users.first_login,
          has_logged_into_app: users.has_logged_into_app,
          company_name: (users.company_name) ? users.company_name : "",
          service: (service_exists) ? users.service : "",
          service_other: (service_exists) ? "" : users.service,
          user_role: users.user_role,
          vendor_id: users.vendor_id || null,
          created_at: users.created_at || null,
          profile_picture: (globalUser && globalUser.profile_picture) ? globalUser.profile_picture : null,
          first_name: users.first_name || '',
          last_name: users.last_name || '',
          location: users.location || null,
          address: (users.location && users.location.address) || '',
        });

        totalClients += agentData.agent_users;
        totalReceived += (users.messages_received) ? users.messages_received : 0;
        totalSent += (users.messages_sent) ? users.messages_sent : 0;
      }

      // Single reactive update
      state.dataUsers = state.dataUsers.concat(newUsers);
      state.dataCompanies = [...companies];
      state.totals['users'] = state.dataUsers.length;
      state.totals['clients'] = totalClients;
      state.totals['received'] = totalReceived;
      state.totals['sent'] = totalSent;
    },
    updateUser(state, data) {
      for (const user of state.dataUsers) {
        if (user.id === data.id) {
          if (data.url) {
            user.url = data.url;
          }
          if (data.status) {
            user.status = data.status;
          }
          if (data.phone_number) {
            user.phone_number = data.phone_number;
            user.phone = user.phone_current = data.phone_number.substring(2);
          }
          if (data.is_admin !== undefined) {
            user.is_admin = data.is_admin;
          }
          if (data.email !== undefined) {
            user.email = data.email;
          }
          if (data.first_name !== undefined) {
            user.first_name = data.first_name;
          }
          if (data.last_name !== undefined) {
            user.last_name = data.last_name;
          }
          if (data.first_name !== undefined || data.last_name !== undefined) {
            user.name = (data.first_name !== undefined ? data.first_name : user.first_name) + ' ' + (data.last_name !== undefined ? data.last_name : user.last_name);
          }
          if (data.company_name !== undefined) {
            user.company_name = data.company_name;
          }
          if (data.service !== undefined) {
            user.service = data.service;
          }
          if (data.location !== undefined) {
            user.location = data.location;
            user.address = (data.location && data.location.address) || '';
          }
          break;
        }
      }
    },
    addOwners(state, data) {
      state.dataOwners = [];
      for (const prop in data) {
        if (data[prop].tenants_list && !data[prop].tenants_list.find(x => x.status === "inactive" && x.tenant_id === state.tenant_id)) {
          state.dataOwners.push({
            text: data[prop].first_name + " " + data[prop].last_name,
            value: data[prop].id
          });
        }
      }
    },
    addVendors(state, data) {
      state.dataVendors = [];
      for (const prop in data) {
        state.dataVendors.push({
          text: data[prop].first_name + " " + data[prop].last_name,
          value: data[prop].id
        });
      }
    },
    addServices(state, services) {
      state.services = [];
      for (const prop in services) {
        state.services.push({
          text: services[prop].name,
          value: services[prop].name,
        });
      }

      if (state.services.length > 12) {
        state.services.push({
          text: 'Other',
          value: ''
        });
      }
    },
    addReferralUrl(state, params) {
      state.userAgentReferrals[params.user_id] = params.link;
    },
    addSingleUser(state, userData) {
      if (state.dataUsers.find(u => u.id === userData.id)) return;
      const globalUser = state.uxDocs.find(u => u.id === userData.owner_id);
      const service_exists = state.services.find(o => o.value === userData.service);
      state.dataUsers.push({
        copied: false,
        id: userData.id,
        owner_id: userData.owner_id,
        device_tokens: (globalUser && globalUser.device_tokens) ? globalUser.device_tokens : [],
        push_notifications_enabled: (globalUser && globalUser.push_notifications_enabled === true) ? true : false,
        push_permission_status: (globalUser && globalUser.push_permission_status) ? globalUser.push_permission_status : null,
        push_permission_synced_at: (globalUser && globalUser.push_permission_synced_at) ? globalUser.push_permission_synced_at : null,
        tenant_id: userData.tenant_id,
        name: (userData.first_name || '') + " " + (userData.last_name || ''),
        email: userData.email || '',
        phone: userData.phone_number ? userData.phone_number.substring(2) : '',
        phone_current: userData.phone_number ? userData.phone_number.substring(2) : '',
        status: userData.status || '',
        is_admin: ["vendor"].includes(userData.user_role) ? true : (userData.is_admin || false),
        messagesReceived: userData.messages_received || 0,
        messagesSent: userData.messages_sent || 0,
        activeClients: userData.active_clients || 0,
        active_clients: userData.active_clients || 0,
        vendor_inquiries: userData.vendor_inquiries || 0,
        AssignedAgent: userData.agent_id ? userData.agent_name : "",
        vendorInquiries: 0,
        url: userData.short_url || "",
        first_login: userData.first_login,
        has_logged_into_app: userData.has_logged_into_app,
        company_name: userData.company_name || "",
        service: service_exists ? userData.service : "",
        service_other: service_exists ? "" : userData.service,
        user_role: userData.user_role,
        vendor_id: userData.vendor_id || null,
        created_at: userData.created_at || null,
        location: userData.location || null,
        address: (userData.location && userData.location.address) || ''
      });
      state.totals['users'] = state.dataUsers.length;
    },
    removeSingleUser(state, userId) {
      const idx = state.dataUsers.findIndex(u => u.id === userId);
      if (idx !== -1) {
        state.dataUsers.splice(idx, 1);
        state.totals['users'] = state.dataUsers.length;
      }
    },
  },
  actions: {
    switch_service: function ({ commit }, data) {
      commit('status_action', 'loading');
      return new Promise(function (resolve, reject) {
        axios.post(config.api_url + 'user/list/update_service', {
          user_id: data.id,
          service: data.value,
        }).then(() => {
          commit('status_action', '');
          resolve('SUCCESS');
        }).catch((error) => {
          commit('status_action', '');
          console.error(error);
          reject(error);
        });
      });
    },

    clear_data: async function ({ commit, state }, payload) {
      const fullReset = payload && payload.fullReset === true;

      // Detach old-tenant Firestore listeners
      if (state.tenantUsersUnsubscribe) {
        state.tenantUsersUnsubscribe();
        state.tenantUsersUnsubscribe = null;
      }
      for (const unsub of state.globalUsersUnsubscribes) unsub();
      state.globalUsersUnsubscribes = [];
      if (state._globalLiveResolve) {
        state._globalLiveResolve();
        state._globalLiveResolve = null;
      }

      state.referralsCache = null;
      state._loadedRole = '';
      state._loadGeneration++;
      commit('removeUsers', fullReset);

      if (fullReset) {
        state.tenant_id = '';
        state.userRole = '';
        state.dataVendors = [];
        state.services = [];
        state.list_invoices = [];
        state.userAgentReferrals = {};
      }
    },
    delete_invoice_selected: function ({ commit }, data) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async function (resolve) {
        let database = firestore;
        let invoiceRef = await database.collection('invoices').doc(data.id).get();
        let invoice_data = invoiceRef.data();
        await database.collection('tenants').doc(invoice_data.sender.tenant_id).collection('chats').doc(invoice_data.chat_id).collection('messages').doc(invoice_data.message_id)
          .set({
            deleted: true,
            modified_date: new Date()
          }, { merge: true });
        await database.collection('invoices').doc(data.id).set({
          deleted: true
        }, { merge: true }).then(async function () {
          let file_to_deleted = await database.collection('tenants').doc(invoice_data.sender.tenant_id).collection('files').where('message_id', '==', invoice_data.message_id).limit(1).get();
          if (!file_to_deleted.empty) {
            file_to_deleted.forEach(async doc => {
              await database.collection('tenants').doc(invoice_data.sender.tenant_id).collection('files').doc(doc.id).delete();
            });
          }
          commit('removeInvoices', true);
          resolve("SUCCESS");
        });
      });
    },
    clear_data_invoices: async function ({ commit }, refreshData = null) {
      commit('removeInvoices', refreshData);
    },

    get_services: async function ({ commit, state }) {
      if (state.services.length > 0) return state.services;
      const dataServices = await axios.get(config.api_url + 'servises');
      const datos = dataServices.data['servises'];
      commit('addServices', datos);
      return state.services;
    },

    get_tenant: async function ({ commit }, user_role) {
      commit('set_role', user_role);
      try {
        const response = await axios.post(config.api_url + 'web/retrieve_logged');
        if (response.data.code === 'SUCCESS') {
          commit('set_tenant', response.data.tenant_id);
        }
        return 'success';
      } catch (error) {
        return 'error';
      }
    },

    set_invoices: async function ({ commit }) {

      let queryUsers = await firestore.collection('users').get();

      // Build user lookup map to avoid O(n*m) nested loop
      const userMap = {};
      for (const user of queryUsers.docs) {
        userMap[user.id] = {
          full_name: user.data().first_name + ' ' + user.data().last_name,
          phone: user.data().phone_number
        };
      }

      let user_current = JSON.parse(localStorage.getItem(config.token_key));
      // Scope the query to the user's tenant. invoices is a global collection;
      // the Firestore rules now restrict reads to members of the invoice's
      // tenant, so an unscoped collection read is rejected. The result was
      // already filtered to user_current.tenant_id below — this just moves the
      // filter server-side.
      let queryInvoices = await firestore.collection('invoices')
        .where('tenant_id', '==', user_current.tenant_id)
        .orderBy('creation_date', 'desc')
        .get();
      let arrayInvoices = [];

      for (const invoice of queryInvoices.docs) {
        let data = invoice.data();

        let roles = data.roles;
        if (user_current.tenant_id === data.tenant_id) {
          let sent_by = userMap[data.sender.owner_id] || {};
          data = {
            ...data,
            id: invoice.id,
            sent_by: sent_by
          };
          if (user_current.user_role === 'vendor' || user_current.user_role === 'employee') {
            let invoice_participants = data.participants;
            let ids = [];
            for (const part of invoice_participants) {
              ids.push(part.user_id);
            }
            if (user_current.user_role === 'vendor' && (data.owner_id == user_current.owner_id || ids.includes(user_current.owner_id))) {
              if (user_current.owner_id !== data.sender.owner_id) {
                data['sent'] = 'Yes'
              }
              arrayInvoices.push(data);
            }
            if (user_current.user_role === 'employee' && (data.owner_id == user_current.vendor_id || ids.includes(user_current.vendor_id))) {
              if (user_current.vendor_id !== data.sender.owner_id) {
                data['sent'] = 'Yes'
              }
              arrayInvoices.push(data);
            }

          }
          if ((user_current.user_role === 'owner' || user_current.user_role === 'agent') && user_current.tenant_id === data.tenant_id && roles.includes(user_current.user_role)) {
            arrayInvoices.push(data);
          }

        }
      }
      commit("setInvoices", arrayInvoices);
    },

    get_users_global: async ({ commit, state }) => {
      // Batch-fetch only the global user docs we need (by owner_id from tenant users)
      const ownerIds = [...new Set(state.uxTenantDocs.map(u => u.owner_id).filter(Boolean))];
      if (ownerIds.length === 0) {
        commit("setUxDocs", []);
        return;
      }
      const batchSize = 30;
      const batches = [];
      for (let i = 0; i < ownerIds.length; i += batchSize) {
        const batch = ownerIds.slice(i, i + batchSize);
        batches.push(
          firestore.collection('users')
            .where(firebase.firestore.FieldPath.documentId(), 'in', batch)
            .get()
        );
      }
      const results = await Promise.all(batches);
      let arrayUsers = [];
      for (const querySnapshot of results) {
        for (const user of querySnapshot.docs) {
          if (user.data().first_name) {
            arrayUsers.push({ ...user.data(), id: user.id });
          }
        }
      }
      commit("setUxDocs", arrayUsers);
    },

    rebuild_data_users: function ({ commit, state }, userRole) {
      const role = userRole || state._loadedRole;
      if (!role || state.uxDocs.length === 0 || state.uxTenantDocs.length === 0) return;

      const roles = [role];
      if (role === 'vendor') roles.push('employee');
      if (role === 'agent') roles.push('owner');

      // Agent stats: one pass over all tenant users
      const activeByAgent = {}, totalByAgent = {};
      for (const u of state.uxTenantDocs) {
        if (u.invited_by_agent) {
          totalByAgent[u.invited_by_agent] = (totalByAgent[u.invited_by_agent] || 0) + 1;
          if (u.is_active) activeByAgent[u.invited_by_agent] = (activeByAgent[u.invited_by_agent] || 0) + 1;
        }
      }

      const uxDocsMap = {};
      for (const doc of state.uxDocs) uxDocsMap[doc.id] = doc;

      const users = [];
      for (const tu of state.uxTenantDocs) {
        if (!roles.includes(tu.user_role)) continue;
        const gu = uxDocsMap[tu.owner_id];
        if (!gu) continue;

        // Merge: tenant fields as base, global fields override (name, email, phone live on global doc)
        const merged = { ...tu, ...gu };

        let agentName = '', agentId = '';
        if (role === 'client') {
          const agentDoc = uxDocsMap[merged.invited_by_agent];
          if (agentDoc) {
            agentName = (agentDoc.first_name || '') + ' ' + (agentDoc.last_name || '');
            agentId = merged.invited_by_agent;
          }
        }

        const service_exists = state.services.find(o => o.value === tu.service);
        users.push({
          copied: false,
          id: tu.id,
          owner_id: tu.owner_id,
          device_tokens: merged.device_tokens || [],
          push_notifications_enabled: merged.push_notifications_enabled === true,
          push_permission_status: merged.push_permission_status || null,
          push_permission_synced_at: merged.push_permission_synced_at || null,
          tenant_id: tu.tenant_id,
          name: (merged.first_name || '') + ' ' + (merged.last_name || ''),
          email: merged.email,
          phone: merged.phone_number ? merged.phone_number.substring(2) : '',
          phone_current: merged.phone_number ? merged.phone_number.substring(2) : '',
          status: tu.status,
          is_admin: merged.is_admin || false,
          messagesReceived: merged.messages_received || 0,
          messagesSent: merged.messages_sent || 0,
          activeClients: activeByAgent[tu.owner_id] || 0,
          active_clients: merged.active_clients || 0,
          vendor_inquiries: merged.vendor_inquiries || 0,
          AssignedAgent: agentId ? agentName : '',
          vendorInquiries: 0,
          url: merged.short_url || '',
          first_login: tu.first_login,
          has_logged_into_app: tu.has_logged_into_app,
          company_name: merged.company_name || '',
          service: service_exists ? tu.service : '',
          service_other: service_exists ? '' : tu.service,
          user_role: tu.user_role.toLowerCase(),
          vendor_id: tu.vendor_id || null,
          created_at: tu.created_at || null,
          agent_name: agentName,
          agent_id: agentId,
          signup_source: tu.signup_source || '',
          signup_heard_from: tu.signup_heard_from || '',
          profile_picture: merged.profile_picture || null,
          first_name: merged.first_name || '',
          last_name: merged.last_name || '',
          // location lives on the tenant doc (referral signup or agent edit);
          // `address` is the flat string the table column sorts/searches on.
          location: merged.location || null,
          address: (merged.location && merged.location.address) || '',
        });
      }

      commit('setDataUsers', { users, userRole: role });
    },

    get_users_global_live: async function ({ commit, dispatch, state }) {
      // Clean up any previous global user listeners
      for (const unsub of state.globalUsersUnsubscribes) unsub();
      state.globalUsersUnsubscribes = [];

      // Resolve any pending previous call so it doesn't hang forever
      if (state._globalLiveResolve) {
        state._globalLiveResolve();
        state._globalLiveResolve = null;
      }

      const ownerIds = [...new Set(
        state.uxTenantDocs.map(u => u.owner_id).filter(Boolean)
      )];
      if (ownerIds.length === 0) {
        commit('setUxDocs', []);
        return;
      }

      const allDocs = {};
      let resolvedBatches = 0;
      const totalBatches = Math.ceil(ownerIds.length / 30);

      return new Promise((resolve) => {
        let resolved = false;
        const safeResolve = () => { if (!resolved) { resolved = true; state._globalLiveResolve = null; resolve(); } };
        state._globalLiveResolve = safeResolve;
        const safetyTimeout = setTimeout(safeResolve, 10000);

        for (let i = 0; i < ownerIds.length; i += 30) {
          const batch = ownerIds.slice(i, i + 30);
          let firstBatchSnapshot = true;

          const unsub = firestore.collection('users')
            .where(firebase.firestore.FieldPath.documentId(), 'in', batch)
            .onSnapshot({ includeMetadataChanges: true }, snap => {
              snap.forEach(d => {
                if (d.data().first_name) {
                  allDocs[d.id] = { id: d.id, ...d.data() };
                }
              });

              if (firstBatchSnapshot) {
                if (!snap.metadata.fromCache) {
                  firstBatchSnapshot = false;
                  resolvedBatches++;
                  if (resolvedBatches === totalBatches) {
                    clearTimeout(safetyTimeout);
                    commit('setUxDocs', Object.values(allDocs));
                    safeResolve();
                  }
                }
              } else if (!resolved) {
                // Metadata-only change during initial load — ignore
              } else {
                // Real-time update to a global user doc
                commit('setUxDocs', Object.values(allDocs));
                dispatch('rebuild_data_users', state._loadedRole);
              }
            }, error => {
              console.error('[UsersListStore] Global users listener error:', error);
              // On error, still resolve so the load doesn't hang
              if (firstBatchSnapshot) {
                firstBatchSnapshot = false;
                resolvedBatches++;
                if (resolvedBatches === totalBatches) {
                  clearTimeout(safetyTimeout);
                  safeResolve();
                }
              }
            });

          state.globalUsersUnsubscribes.push(unsub);
        }
      });
    },

    get_users_from_tenant: async function ({ commit, dispatch, state }) {
      if (state.tenantUsersUnsubscribe) {
        state.tenantUsersUnsubscribe();
        state.tenantUsersUnsubscribe = null;
      }

      if (state.tenant_id !== '') {
        let tenantDoc = await firestore.collection('tenants')
          .doc(state.tenant_id)
          .get();
        const tenantData = {
          ...tenantDoc.data(),
          id: tenantDoc.id
        };

        return new Promise((resolve) => {
          let firstSnapshot = true;
          let resolved = false;
          const safeResolve = () => { if (!resolved) { resolved = true; resolve(); } };
          const safetyTimeout = setTimeout(safeResolve, 10000);

          state.tenantUsersUnsubscribe = firestore.collection('tenants')
            .doc(state.tenant_id)
            .collection('users')
            .onSnapshot({ includeMetadataChanges: true }, (snapshot) => {
              let arrayUsers = [];
              for (const user of snapshot.docs) {
                if (user.data().owner_id) {
                  let data = user.data();
                  data = {
                    ...data,
                    id: user.id,
                  };
                  arrayUsers.push(data);
                }
              }

              let userToUpdate = arrayUsers.find(x => x.owner_id === tenantData.owner_id);
              if (userToUpdate) {
                userToUpdate.user_role = tenantData.user_role;
                userToUpdate.first_login = tenantData.first_login;
                userToUpdate.has_logged_into_app = tenantData.has_logged_into_app;
              }

              let clients_active = 0;
              for (const x of arrayUsers) {
                if (x.user_role == 'client' && x.is_active) {
                  clients_active++;
                }
              }
              state.totals['clients_active'] = clients_active;
              commit("setUxTenantDocs", arrayUsers);

              if (firstSnapshot) {
                if (!snapshot.metadata.fromCache) {
                  firstSnapshot = false;
                  clearTimeout(safetyTimeout);
                  safeResolve();
                }
              } else if (state.status === 'loading') {
                // Initial get_users still in progress — don't interfere, it will handle rebuild
              } else {
                // Real-time update: check if new tenant users need global doc listeners
                const currentUxDocIds = new Set(state.uxDocs.map(d => d.id));
                const hasNewOwnerIds = arrayUsers.some(u => u.owner_id && !currentUxDocIds.has(u.owner_id));

                if (hasNewOwnerIds) {
                  dispatch('get_users_global_live').then(() => {
                    dispatch('rebuild_data_users', state._loadedRole);
                  });
                } else {
                  dispatch('rebuild_data_users', state._loadedRole);
                }
              }
            }, error => {
              console.error('[UsersListStore] Tenant users listener error:', error);
            });
        });
      }
    },
    // eslint-disable-next-line no-empty-pattern
    generate_token: function ({ }, params) {
      return new Promise(function (resolve) {
        axios
          .post(config.api_url + 'web/generateAgentReferral', params)
          .then((response) => {
            resolve(response.data.token);
          });
      });
    },
    get_invoices: async function ({ dispatch }) {
      await dispatch('set_invoices');
    },
    get_users: async function ({ commit, dispatch, state }, userRole) {
      if (state.dataUsers.length > 0 && state._loadedRole === userRole) {
        commit('success');
        return;
      }

      const myGeneration = state._loadGeneration;
      commit('loading');

      try {
        const initialFetches = [];
        if (state.services.length === 0) initialFetches.push(dispatch('get_services'));
        if (state.uxTenantDocs.length === 0) initialFetches.push(dispatch('get_users_from_tenant'));
        if (initialFetches.length > 0) await Promise.all(initialFetches);

        if (state._loadGeneration !== myGeneration) { commit('success'); return; }

        // Fetch global user docs — may need multiple passes if tenant docs grow
        // (Firestore can fire partial first snapshot, then full data arrives)
        let globalFetchNeeded = state.uxDocs.length === 0;
        while (globalFetchNeeded) {
          const preOwnerCount = state.uxTenantDocs.length;
          await dispatch('get_users_global_live');

          if (state._loadGeneration !== myGeneration) { commit('success'); return; }

          // If tenant docs grew while we were fetching, re-fetch to cover new users
          globalFetchNeeded = state.uxTenantDocs.length > preOwnerCount;
        }

        if (state._loadGeneration !== myGeneration) { commit('success'); return; }
      } catch (e) {
        console.error('[get_users] error:', e);
        commit('success');
        return;
      }

      dispatch('rebuild_data_users', userRole);
      dispatch('get_owners', userRole);
      commit('success');

      // Background: generate referral tokens for agents (non-blocking)
      if (userRole === "agent") {
        const tokenResults = [];
        const tokenPromises = [];
        for (const user of state.dataUsers) {
          if (!state.userAgentReferrals[user.owner_id] && (user.user_role === 'agent' || user.user_role === 'owner')) {
            tokenPromises.push(
              dispatch("generate_token", {
                user_id: user.owner_id,
                tenant_id: state.tenant_id
              }).then(shortUrl => {
                tokenResults.push({ id: user.id, url: shortUrl });
              }).catch(() => {})
            );
          }
        }
        if (tokenPromises.length > 0) {
          Promise.all(tokenPromises).then(() => {
            for (const result of tokenResults) {
              commit("updateUser", result);
            }
          });
        }
      }
    },

    resend_invite: function ({ commit }, data) {
      commit('status_action', 'loading');
      const users = data.users || [];
      return new Promise(function (resolve) {
        Promise.all(users.map(u =>
          axios.post(config.api_url + 'user/list/send_invite', {
            email: u.email,
            phone_number: u.phone,
            name: u.name,
            user_role: u.user_role,
          }).then(response => {
            const d = (response && response.data) || {};
            return {
              user: u,
              email_status: d.email_status || 'unknown',
              email_skip_reason: d.email_skip_reason || null,
              sms_status: d.sms_status || 'unknown',
              sms_skip_reason: d.sms_skip_reason || null,
            };
          }).catch(err => {
            console.error('resend_invite failed for', u.email || u.phone, err && err.message);
            return { user: u, email_status: 'failed', sms_status: 'failed', error: err && err.message };
          })
        )).then(results => {
          commit('status_action', '');
          resolve(results);
        });
      });
    },

    switch_admin: function ({ commit }, user) {
      commit('status_action', 'loading');
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async function (resolve) {
        try {
          let xuser = {
            user_id: user.id,
            is_admin: !(user.is_admin)
          };

          await axios.post(config.api_url + 'user/list/is_admin', xuser).then(response => {
            resolve(response);
            if (response.status === 200) {
              commit('status_action', '');
              commit('updateUser', { id: user.id, is_admin: response.data.parameters });
            }
          });

        } catch (error) {
          console.error(error);
        }
      });
    },
    update_email: function ({ commit, state }, data) {
      return new Promise(function (resolve, reject) {
        axios.post(config.api_url + 'user/list/update_email', {
          user_id: data.owner_id,
          new_email: data.new_email,
        }).then(() => {
          let currentUser = state.dataUsers.find(x => x.owner_id === data.owner_id);
          if (currentUser) {
            commit('updateUser', {id: currentUser.id, email: data.new_email});
          }
          resolve();
        }).catch((error) => {
          reject(error);
        });
      });
    },
    update_user: function ({ commit, state }, data) {
      return new Promise(function (resolve, reject) {
        const payload = { user_id: data.owner_id };
        if (data.first_name !== undefined) payload.first_name = data.first_name;
        if (data.last_name !== undefined) payload.last_name = data.last_name;
        if (data.company_name !== undefined) payload.company_name = data.company_name;
        if (data.email !== undefined) payload.email = data.email;
        if (data.phone !== undefined) payload.phone_number = config.phone_extension + data.phone;
        if (data.location !== undefined) payload.location = data.location;
        axios.post(config.api_url + 'user/list/update_user', payload).then(() => {
          let currentUser = state.dataUsers.find(x => x.owner_id === data.owner_id);
          if (currentUser) {
            const mutation = { id: currentUser.id };
            if (data.first_name !== undefined) mutation.first_name = data.first_name;
            if (data.last_name !== undefined) mutation.last_name = data.last_name;
            if (data.company_name !== undefined) mutation.company_name = data.company_name;
            if (data.email !== undefined) mutation.email = data.email;
            if (data.phone !== undefined) {
              mutation.phone_number = config.phone_extension + data.phone;
            }
            if (data.location !== undefined) mutation.location = data.location;
            commit('updateUser', mutation);
          }
          resolve();
        }).catch((error) => {
          reject(error);
        });
      });
    },
    update_profile: function ({ commit, state }, data) {
      return new Promise(function (resolve, reject) {
        const payload = {
          user_id: data.owner_id,
          first_name: data.first_name,
          last_name: data.last_name,
        };
        if (data.company_name !== undefined) {
          payload.company_name = data.company_name;
        }
        axios.post(config.api_url + 'user/list/update_profile', payload).then(() => {
          let currentUser = state.dataUsers.find(x => x.owner_id === data.owner_id);
          if (currentUser) {
            commit('updateUser', {
              id: currentUser.id,
              first_name: data.first_name,
              last_name: data.last_name,
              company_name: data.company_name,
            });
          }
          resolve();
        }).catch((error) => {
          reject(error);
        });
      });
    },
    update_phone_number: function ({ commit, state }, data) {
      commit('loading');
      return new Promise(function (resolve) {
        let errorsCounter = null;
        axios.post(config.api_url + 'web/updatePhoneNumberUser', {
          new_phone_number: config.phone_extension + data.new_phone_number,
          phone_number: config.phone_extension + data.phone_number
        }).then(() => {
          let currentUser = state.dataUsers.find(x => x.owner_id === data.owner_id);
          if (currentUser) {
            commit("updateUser", { id: currentUser.id, phone_number: config.phone_extension + data.new_phone_number });
          }
          commit("success");
          resolve(errorsCounter);
        }).catch((error) => {
          errorsCounter = error.response.data;
          commit("success");
          resolve(errorsCounter);
        });
      });
    },

    delete_client: function ({ commit }, users) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async function (resolve) {
        try {
          for (const prop in users) {
            commit('status_action', 'loading');
            await axios.post(config.api_url + 'user/me/delete', {
              user_id: users[prop].owner_id
            }).then(async response => {
              if (response.status === 200) {
                commit('status_action', '');
              }
            });

          }
          resolve(true);
        } catch (error) {
          console.error(error);
        }
      });
    },

    delete_transfer: function ({ commit }, info) {

      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async function (resolve) {
        try {

          for (const prop in info.users) {
            commit('status_action', 'loading');
            await axios.post(config.api_url + 'user/list/transfer_user', {
              user_id: info.users[prop].id,
              transfer_id: info.transfer_to,
              transfer_owner: info.transfer_owner
            });
          }
          commit('status_action', '');
          resolve(true);
        } catch (error) {
          console.error(error);
        }
      });
    },
    delete_vendor: function ({ commit, dispatch, state }, info) {

      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async function (resolve) {
        try {

          for (const prop in info.users) {
            commit('status_action', 'loading');
            let database = firestore;
            let employeesToDelete = await database.collection('tenants')
              .doc(state.tenant_id)
              .collection('users')
              .where("vendor_id", "==", info.users[prop].owner_id)
              .get();
            if (employeesToDelete.docs.length > 0) {
              for (const employee of employeesToDelete.docs) {
                try {
                  await axios.post(config.api_url + 'user/me/delete', {
                    user_id: employee.data().owner_id
                  });
                } catch (error) {
                  console.error(error)
                }
              }
            }
            await axios.post(config.api_url + 'user/me/delete', {
              user_id: info.users[prop].owner_id,
              transfer_id: info.transfer_to,
              disable_account: true
            });
          }
          commit('removeUsers', true);
          await dispatch('get_users', state.userRole);
          commit('status_action', '');
          resolve(true);
        } catch (error) {
          console.error(error);
        }
      });
    },

    get_owners: async function ({ commit, state, rootState }, userRole) {
      commit('status_action', 'loading');

      let userRolesToSearch = [userRole];
      if (userRole === "vendor") {
        userRolesToSearch.push("employee");
      }
      if (userRole === "agent") {
        userRolesToSearch.push("owner");
      }

      if (state.tenant_id !== '') {
        let list = [];
        try {
          let onlyAgents = state.uxTenantDocs;

          // Build lookup map for O(1) user retrieval
          const uxDocsMap = {};
          for (const doc of state.uxDocs) {
            uxDocsMap[doc.id] = doc;
          }

          for (const userDetail of onlyAgents) {
            if (userRolesToSearch.includes(userDetail['user_role']) || userDetail['owner_id'] === rootState.Authenticate.user.owner_id) {
              let globalUser = uxDocsMap[userDetail.owner_id];
              let user_complete = globalUser ? { ...userDetail, ...globalUser } : false;
              if (!user_complete) continue;
              user_complete = {
                ...user_complete,
                id: userDetail.id
              };

              //if (user_complete["owner_id"] !== state.user['owner_id']) {
              list.push(user_complete);
              // }
            }

          }
          await commit('addOwners', list);
          commit('status_action', '');

        } catch (error) {
          console.error(error);
          commit('status_action', '');
        }
      } else {
        // No user is signed in.
        commit('status_action', '');
      }


    },
  },
  getters: {
    agentsToTransfer(state) {
      return state.dataOwners;
    },
    vendorsToTransfer(state) {
      return state.dataUsers.filter(x => x.status !== "inactive" && x.tenant_id === state.tenant_id).map(x => {
        return { text: `${x.name}`, value: x.owner_id }
      });
    },
  }
}
